import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import organizationsIcon from "../../Common/_assets/icons/icon_module_organizations.svg";
import { Selectors } from "../../Everou/_reducers/app.reducer";
import { Organization } from "../../Organizations/_models/Organization";
import { PMSActiveOrganizationStore } from "../_stores/PMSActiveOrganizationStore";

type Props = {
    activeOrganization: Organization | null;
};

// Shows which organization an organization-centric module (Customization,
// Integrations) is operating on; with several organizations it becomes a
// picker that updates the shared active-organization choice.
export function PMSOrganizationScopeSelector({ activeOrganization }: Props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const organizations: Organization[] = useSelector(
        Selectors.getOrganizations,
    );

    if (!activeOrganization) return null;

    return (
        <div className="d-flex align-items-center c-bg-grey-245 c-rounded-big p-3 mb-3">
            <img
                src={organizationsIcon}
                alt=""
                className="c-img-1-5rem mr-3"
            />
            <div className="flex-grow-1">
                <div className="font-weight-bold text-uppercase small text-secondary">
                    {t("mod_organizations_title")}
                </div>
                {organizations.length <= 1 ? (
                    <div className="font-weight-bold">
                        {activeOrganization.name}
                    </div>
                ) : (
                    <select
                        className="form-control font-weight-bold mt-1"
                        value={activeOrganization.uid}
                        onChange={(e) =>
                            dispatch(
                                PMSActiveOrganizationStore.actionSet(
                                    e.target.value,
                                ),
                            )
                        }
                    >
                        {organizations.map((organization) => (
                            <option
                                key={organization.uid}
                                value={organization.uid}
                            >
                                {organization.name}
                            </option>
                        ))}
                    </select>
                )}
            </div>
        </div>
    );
}
